import { render, staticRenderFns } from "./RecipeDetails.vue?vue&type=template&id=cffb8ee0&scoped=true&"
import script from "./RecipeDetails.vue?vue&type=script&lang=js&"
export * from "./RecipeDetails.vue?vue&type=script&lang=js&"
import style0 from "./RecipeDetails.vue?vue&type=style&index=0&id=cffb8ee0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffb8ee0",
  null
  
)

export default component.exports